/**
 * MentionText — renders a plain string that may contain inline mentions.
 * Mention tokens `[@Label](kind:id)` become provider-rendered chips;
 * everything else is plain text preserving newlines.
 */

import React from 'react';
import { parseMentions } from '../parse';
import { getMentionProvider } from '../registry';
import { MentionChip } from './MentionChip';

export interface MentionTextProps {
  text: string;
  className?: string;
}

export function MentionText({ text, className }: MentionTextProps) {
  const segments = parseMentions(text);
  return (
    <span className={className}>
      {segments.map((seg, i) => {
        if (seg.type === 'text') {
          return <React.Fragment key={i}>{seg.value}</React.Fragment>;
        }
        const provider = getMentionProvider(seg.kind);
        if (provider) {
          const chip = provider.renderChip({ id: seg.id, label: seg.label });
          return <React.Fragment key={i}>{chip}</React.Fragment>;
        }
        // Unknown kind — render a passive chip.
        return <MentionChip key={i} id={seg.id} label={seg.label} kind={seg.kind} />;
      })}
    </span>
  );
}
